
export default function infinityText() {
    const links = document.querySelectorAll(".js-text");
    const marquee = document.querySelector('.text-single');

    if (!marquee || !links.length) return;

    // Horizontal loop helper function
    function horizontalLoop(items, config) {
        // Ensure items array and config object are correct
        items = gsap.utils.toArray(items);
        config = config || {};
        let tl = gsap.timeline({ repeat: -1, paused: config.paused, defaults: { ease: "none" } });
        let totalWidth = 0;

        items.forEach((item, i) => {
            let width = item.offsetWidth;
            totalWidth += width;
            tl.to(item, { x: `-=${width}`, duration: config.speed || 10, ease: "none" }, i * -width / totalWidth)
              .fromTo(item, { x: totalWidth }, { x: 0, duration: 0 });
        });

        return tl;
    }

    // Create the horizontal loop with your desired settings
    let loop = horizontalLoop(links, {
        repeat: -1,
        speed: 5,
        paused: false,
        draggable: true,
    });

    // Pause on hover
    marquee.addEventListener("mouseenter", () => {
        loop.pause();
    });

    marquee.addEventListener("mouseleave", () => {
        loop.play();
    });

    // Change speed on scroll
    let currentScroll = 0;
    let scrollDirection = 1;

    window.addEventListener("scroll", () => {
        let direction = window.pageYOffset > currentScroll ? 1 : -1;
        if (direction !== scrollDirection) {
            gsap.to(loop, { timeScale: direction, overwrite: true });
            scrollDirection = direction;
        }
        currentScroll = window.pageYOffset;
    });
}
